import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { UserStatus } from '../types';

interface UserStatusBadgeProps {
  status: UserStatus;
  className?: string;
}

export function UserStatusBadge({ status, className }: UserStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      className={`rounded-full ${className || ''}`}
      variant={
        status === 'BLOCKED'
          ? 'destructive'
          : status === 'ACTIVE'
          ? 'default'
          : 'secondary'
      }
    >
      {t(`status.${status}`)}
    </Badge>
  );
}
